


























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import historyList from '@/components/history/List.vue'
import ffButton from '@/components/public/Button.vue'
import uploadList from '@/components/upload/List.vue' 
import { namespace} from 'vuex-class'
const appStore = namespace('app')
@Component({
  components: {
    historyList,
    uploadList,
    ffButton
  }
})
export default class HistoryListPage extends Vue {
  @appStore.State(state => state.isLogin) isLogin: boolean
  @Prop({
    type: Array,
    required: true
  })
  fileList!: object[]
  activeName = 'processing'
  title: object = {
    'images': 'Upload List'
  }
  uploadingList: object[] = []
  completedList: object[] = []
  uploadPageList: object[] = [] // processing now-page show front-end fileList
  uploadingTotal = 0 // server Uploading items
  uploadListTotal = 0 // all uploading items includes front-end fileList and server Uploading items
  completedTotal = 0
  pageSize = 30 // 每页展示数
  searchVal = '' // 搜索值
  loading = true // 加载
  reverse = true // 默认倒序
  completePage = 1 // 完成当前激活的页数
  progressPage = 1 // 进行当前激活页码
  disabledTab = false
  processChangePage = false // 正在上传是否切换页码不为第一页
  @Watch('isLogin')
  isLoginChange(val: boolean) {
    if (!val) {
      this.uploadingList = []
      this.completedList = []
      this.uploadPageList = []
      this.uploadListTotal = 0
      this.completedTotal = 0
    } else {
      this.allHistory()
    }
  }
  refresh (): void {
    this.loading = true
    this.togglePage(0, 0) // 进行中的列表刷新状态
  }
  clearSearch (): void {
    this.searchVal = ''
    this.changePage(1)
  }
  updateUploading (fileList: any): void { // fileList 为点击上传图片文件
    this.uploadListTotal = 0
    this.uploadListTotal = fileList.length + this.uploadingTotal
    this.uploadPageList = this.fileList.slice(0, this.pageSize - this.uploadingTotal)
    this.activeName = 'processing'
  }
  processingPage (page: number): void {
    if (page === 1) {
      this.processChangePage = false
      this.uploadPageList = this.fileList.slice(0, this.pageSize -this.uploadingTotal)
    } else {
      const pageStart = (page - 1) * this.pageSize - this.uploadingTotal
      this.uploadPageList = this.fileList.slice(pageStart, pageStart + this.pageSize)
      this.processChangePage = true
    }
  }
  allHistory (): void {
    if (!this.isLogin) {
      return
    }
    this['$api'].get(`/all?offset=0&limit=30&reverse=true`).then((res: object) => {
      const data = res['data']
      this.loading = false
      this.uploadingList = data['uploading']['records']
      this.uploadingTotal = data['uploading']['total']

      this.completedList = data['completed']['records']
      this.completedTotal = data['completed']['total']

      if (this.uploadingList.length === 0) {
        this.activeName = 'completed'
      }
    })
  }
  changePage (page: number): void {
    this.loading = true
    this.disabledTab = true
    this.searchVal = ''
    const offset = (page - 1) * 30
    switch (this.activeName) {
      case 'processing':
        this.disabledTab = false
        this.loading = false
        return
      case 'completed':
        this.togglePage(1, offset, this.reverse)
        break
      default:
        this.togglePage(1, offset, this.reverse)
        break
    }
  }
  search () {
    this.loading = true
    switch (this.activeName) {
      case 'processing':
        this.progressPage = 1
        this.togglePage(0, 0, this.reverse, this.searchVal)
        break
      case 'completed':
        this.completePage = 1
        this.togglePage(1, 0, this.reverse, this.searchVal)
        break
      default:
        this.completePage = 1
        this.togglePage(1, 0, this.reverse, this.searchVal)
        break
    }
  }
  togglePage (status: number, offset: number, reverse = true, word?: string): void {
    this['$api'].get('/info', {
      params: {
        status: status,
        offset: offset,
        limit: 30,
        reverse: reverse,
        word: word
      }
    }).then((res: object) => {
      const data = res['data']
      if (status === 0) {
        this.uploadingList = data['records']
        this.uploadingTotal = data['total']
      }
      if (status === 1) {
        this.completedList = data['records']
        this.completedTotal = data['total']
      }
      this.loading = false
      this.disabledTab = false
    }).catch(() => {
      this.disabledTab = false
    })
  }
  toggleSort (): void {
    this.reverse = !this.reverse
    this.search()
  }
  tryUpload (uid: number) {
    this.$emit('try-upload', uid)
  }
  mounted(): void {
    this.allHistory()
  }
}
